'use client';

import { HStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { camel } from 'radash';
import { getAutoDisplayFeatureTags } from '@terra/shared-schemas-orchestrator';
import { Badge } from '../../components/badge';

type EndpointFeatureTagBadgesProps = {
  assetTags: readonly string[] | null | undefined;
};

export function EndpointFeatureTagBadges({
  assetTags,
}: EndpointFeatureTagBadgesProps) {
  const t = useTranslations('designSystem.applicationAssets.featureTags');
  const activeFeatureTags = getAutoDisplayFeatureTags({ assetTags });

  if (activeFeatureTags.length === 0) {
    return null;
  }

  return (
    <HStack gap={1} flexWrap="wrap" flexShrink={0}>
      {activeFeatureTags.map((tag) => (
        <Badge key={tag} variant="outline" size="sm">
          {t(camel(tag))}
        </Badge>
      ))}
    </HStack>
  );
}
